module.exports = __webpack_public_path__ + "img/font-football.d67b3723.png";